import { render, staticRenderFns } from "./LastProductSelected.vue?vue&type=template&id=249cf4cf"
import script from "./LastProductSelected.vue?vue&type=script&lang=js"
export * from "./LastProductSelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports